module.exports = __webpack_public_path__ + "static/media/AE.b581ef6c.png";